import { database } from '../../App'
import { convertUnixToDate } from '../../utils/conversion'

export default function UserDTO(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getDataFromMajor(payload.data || {})
      resolve({
        id: payload.id || '',
        name: payload.data?.name || '',
        'join-date': payload.data?.['join-date'] || '',
        course: payload.data?.course || '',
        groups: payload.data ? payload.data.groups.join(', ') : '',
        email: payload.data?.email || '',
        personalEmail: payload.data?.personalEmail || '',
        phoneNumber: payload.data?.phoneNumber || '',
        class: payload.data?.class || '',
        faculty: result ? result.faculty : '',
        school: result ? result.school : '',
        status: payload.data?.status || '',
        books: payload.data?.books ? payload.data.books : '',
        devices: payload.data?.devices,
        totalPayment: payload.data?.['total-payment'] || 0,
        major: payload.data?.major || '',
      })
    } catch (error) {
      console.error('Error in UserDTO:', error)
    }
  })
}

export function UserRawDTO(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getDataFromMajor(payload.data || {})
      resolve({
        id: payload.id || '',
        name: payload.data?.name || '',
        'join-date': payload.data?.['join-date'] || '',
        course: payload.data?.course || '',
        groups: payload.data?.groups ?? '',
        email: payload.data?.email || '',
        personalEmail: payload.data?.personalEmail || '',
        phoneNumber: payload.data?.phoneNumber || '',
        class: payload.data?.class || '',
        faculty: result ? result.faculty : '',
        school: result ? result.school : '',
        status: payload.data?.status || '',
        books: payload.data?.books ? payload.data.books.join(', ') : '',
        devices: payload.data?.devices ? payload.data.devices.join(' ') : '',
        totalPayment: payload.data?.['total-payment'] || '',
        major: payload.data?.major || '',
      })
    } catch (error) {
      console.error('Error in UserDTO:', error)
    }
  })
}
export function newUserDTO(payload) {
  if (!Array.isArray(payload)) {
    throw Error("There's somethign wrong please contact admin")
  }
  return payload.map((item) => ({
    // uuid: item.uuid || '',
    tid: item.id || '',
    name: item.name || '',
    joinDate: convertUnixToDate(item.joinDate),
    course: item.course,
    groups: item.groups || [],
    schoolEmail: item.schoolEmail,
    personalEmail: item.personalEmail || '',
    phoneNumber: item.phoneNumber || '',
    className: item.className || '',
    faculty: item.faculty,
    school: item.school,
    status: item.status || '',
    books: item.books || [],
    devices: item.devices,
    id: item.uuid,
    // totalPayment: item.totalPayment,
    // accountType: item.accountType || '',

    // major: item.major || '',
  }))
}
export const fetchMajors = async () => {
  try {
    const response = await database.document('configuration', 'categorize')
    const mapping = JSON.parse(response['data']['major-mapping'])
    return mapping
  } catch (error) {
    console.error('Cannot fetch major data:', error)
    return []
  }
}

export const getDataFromMajor = async (user) => {
  if (!user || !user.major) {
    return { school: '', faculty: '' }
  }

  const data = await fetchMajors()
  if (!data || data.length === 0) {
    return { school: '', faculty: '' }
  }

  const normalizeMajor = user.major
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')

  for (let i = 0; i < data.length; i++) {
    const school = data[i]
    for (const faculty of school.faculties) {
      for (const major of faculty.majors) {
        const normalizeName = major
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
        if (normalizeMajor.includes(normalizeName)) {
          return {
            school: school.name,
            faculty: faculty.name,
          }
        }
      }
    }
  }

  return { school: '', faculty: '' }
}
